import React from "react";
import { useProfile } from "../context/ProfileContext";
import { ProfileType, PROFILE_LABELS } from "../types";

type Props = {
  layout?: "horizontal" | "vertical";
};

export default function ProfileSelector({ layout = "horizontal" }: Props) {
  const { profile, setProfile } = useProfile();

  const entries = Object.entries(PROFILE_LABELS) as [ProfileType, string][];
  const specific = entries.filter(([key]) => key !== "all");
  const all = entries.find(([key]) => key === "all")!;
  const ordered = [...specific, all];

  if (layout === "vertical") {
    return (
      <div className="flex flex-col gap-1">
        {ordered.map(([key, label]) => (
          <button
            key={key}
            onClick={() => setProfile(key)}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium text-left transition-all duration-200
              ${
                profile === key
                  ? "bg-neutral-900 dark:bg-white text-white dark:text-neutral-900"
                  : "text-neutral-500 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-white/[0.06] hover:text-neutral-900 dark:hover:text-neutral-100"
              }`}
          >
            {label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {ordered.map(([key, label]) => (
        <button
          key={key}
          onClick={() => setProfile(key)}
          className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all duration-300
            ${
              profile === key
                ? "bg-neutral-900 dark:bg-white text-white dark:text-neutral-900 shadow-lg shadow-neutral-900/20 dark:shadow-white/10"
                : "glass-card text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-100 hover:border-neutral-300 dark:hover:border-white/10"
            }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
